import { render } from "./AssetDetails.vue?vue&type=template&id=d83b72e2&scoped=true"
import script from "./AssetDetails.vue?vue&type=script&lang=js"
export * from "./AssetDetails.vue?vue&type=script&lang=js"

import "./AssetDetails.vue?vue&type=style&index=0&id=d83b72e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d83b72e2"

export default script